import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import {
  Button,
  Drawer,
  Dropdown,
  Menu,
  message,
  Pagination,
  PaginationProps,
  Row,
  Space,
  TabsProps,
  Tag,
} from "antd";
import copy from "clipboard-copy";
import { useEffect, useState } from "react";
import { CommonButton } from "../../components/CommonButton/button";
import { Text } from "../../components/CommonFont/text";
import { SearchBox } from "../../components/CommonSearchBox";
import { CommonTable } from "../../components/commonTable";
import { TableCard } from "../../components/CommonTableCard";
import { CloseOrder } from "../../components/Drawer/CloseOrder";
import "./index.css";

import { saveAs } from "file-saver";
import _ from "lodash";
import {
  useExportSalesReportMutation,
  useGetAllOrdersQuery,
  useGetEnquiryCategoryQuery,
  useGetOrderByIdQuery,
  useGetOrderDownloadDataQuery,
  useGetQuotationOrNpdQuery,
  useGetSalesAfterNpdQuotationQuery,
  useGetSalesAfterQuotationQuery,
} from "../../services/api";

import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import moment from "moment";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import OrderFilter from "../../components/CommonFilter/orderFilter";
import { OrderPdf } from "../../components/Export/orderPdf";
import { getContactsParams } from "../../helpers/quarery";
import {
  getDefaultOrderSelectedColumns,
  OrderColumnLabels,
  OrderExportColumn,
  OrderTableColumn,
} from "./orderColumns";
import ExportModal from "../../components/Modals/ReportsModal/ExportModal";
import MultiSelectFilter from "../../components/Modals/ReportsModal/MultiSelectFilter";
export const Orders = () => {
  const [open, setOpen] = useState(false);
  const [isInProgress, setIsProgress] = useState(false);
  const [isDispatch, setDispatch] = useState(false);
  const [isDelivery, setDelivery] = useState(false);
  const [isCompleted, setCompleted] = useState(false);
  const [orderStatus, setorderStatus] = useState(0);
  const [filter, setFilter] = useState(false);
  const [filterData, setFilterData] = useState<any>();
  const [selectedRegion, setSelectedRegion] = useState([]);
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [npdData, setNpdData] = useState<any>();
  const [quotationData, setQuotationData] = useState<any>();
  const [quotationByIdData, setQuotationByIdData] = useState<any>();

  const id = searchParams.get("id");

  const [downloadIds, setDownloadIds] = useState<any>();
  const {
    currentData: dataById,
    isLoading: dataByIdLoading,
    isFetching: dataByIdFetching,
  } = useGetOrderByIdQuery(id, { skip: !id });
    
  const { data: npdOrQuotationData, isLoading: npdOrQuotationDataLoading } =
    useGetQuotationOrNpdQuery(dataById?.data?.quotation);
  const isOrderPdfReady = Boolean(
    id &&
      !dataByIdLoading &&
      !dataByIdFetching &&
      String(dataById?.data?.id) === String(id) &&
      quotationByIdData?.data?.items &&
      (quotationData?.data?.[0] || npdData?.data?.[0]),
  );
  const handleOrderPdfDownload = async () => {
    const selectedId = id;
    if (
      !selectedId ||
      dataByIdLoading ||
      dataByIdFetching ||
      !dataById?.data ||
      String(dataById.data.id) !== String(selectedId) ||
      !quotationByIdData?.data?.items ||
      !(quotationData?.data?.[0] || npdData?.data?.[0])
    ) {
      return;
    }
    const blob = await pdf(
      <OrderPdf
        quotationData={quotationData}
        quotationByIdData={quotationByIdData}
        npdData={npdData}
        data={dataById}
      />,
    ).toBlob();
    saveAs(
      blob,
      `Order_${
        quotationData?.data[0]?.sales_lead_id
          ? quotationData?.data[0]?.sales_lead_id
          : npdData?.data[0]?.sales_lead_id
      }.pdf`,
    );
  };
  // const { data: npdData, isLoading: npdLoading } =
  //   useGetSalesAfterNpdQuotationQuery(npdOrQuotationData?.data[0]?.npd);

  // const { data: quotationData, isLoading: loadingQuery } =
  //   useGetSalesAfterQuotationQuery(npdOrQuotationData?.data[0]?.sales_lead);
  const userId = localStorage.getItem("user_id");
  const navigate = useNavigate();

  const search = searchParams.get("search");

  // ---------------modal---------------

  // Enquiry Category filter states
  const [enquiryCategoryIds, setEnquiryCategoryIds] = useState<number[]>([]);

  // Column selection state using enum
  const [selectedColumns, setSelectedColumns] = useState<Record<string, boolean>>(
    getDefaultOrderSelectedColumns(),
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Export mutation
  const [exportSalesReport, { isLoading: isExporting }] =
    useExportSalesReportMutation();

  // Fetch data for enquiry category filter
  const { data: enquiryCategoryData } = useGetEnquiryCategoryQuery({});

  const showModal = () => {
    setIsModalOpen(true);
  };

  const resetModalFilters = () => {
    setEnquiryCategoryIds([]);
    setSelectedColumns(getDefaultOrderSelectedColumns());
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModalFilters();
  };

  // ---------------modal---------------

  const [pageData, setPageData] = useState<{
    page: number;
    pageSize: number;
  }>({
    page: 0,
    pageSize: 5,
  });
  const params = getContactsParams(pageData.page, pageData.pageSize);

  const getAllContactsParams = {
    id: userId,
    order_status: orderStatus,
    params: params,
    search: search ? search : "",
    body: JSON.stringify(filterData)
      ? JSON.stringify(filterData)
      : JSON.stringify({}),
  };

  const { data, isLoading, refetch, isFetching } =
    useGetAllOrdersQuery(getAllContactsParams);
  const idArray = _.map(data?.results, "id");
  useEffect(() => {
    refetch();
    setPageData({ page: 0, pageSize: 5 });
  }, [orderStatus]);
  const onClose = () => {
    setOpen(false);
    setNpdData(undefined);
    setQuotationData(undefined);
    setQuotationByIdData(undefined);
    navigate("/order");
  };
  const onPaginationChange = (page: number, pageSize: number) => {
    setPageData({ page, pageSize });
  };
  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      date: "11/05/2023",
      code: "CH 1",
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      date: "11/05/2023",
      code: "CH 1",
      address: "10 Downing Street",
    },
  ];
  const Companyname = ({ id }: any) => {
    const { data: npdOrQuotationData, isLoading: npdOrQuotationDataLoading } =
      useGetQuotationOrNpdQuery(id);
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(npdOrQuotationData?.data[0]?.sales_lead);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npdOrQuotationData?.data[0]?.npd,
    );

    // useEffect(() => {
    //   if (npdOrQuotationData?.data[0]?.sales_lead) {
    //     trigger(npdOrQuotationData?.data[0]?.sales_lead);
    //   }
    // }, [npdOrQuotationData?.data[0]?.sales_lead]);
    return (
      <>
        <div>
          {quotationData?.data[0]?.company_name
            ? quotationData?.data[0]?.company_name
            : npdData?.data[0]?.company_name}
        </div>
      </>
    );
  };
  const Code = ({ id }: any) => {
    const { data: npdOrQuotationData, isLoading: npdOrQuotationDataLoading } =
      useGetQuotationOrNpdQuery(id);
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(npdOrQuotationData?.data[0]?.sales_lead);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npdOrQuotationData?.data[0]?.npd,
    );

    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]?.sales_lead_id
            ? quotationData?.data[0]?.sales_lead_id
            : npdData?.data[0]?.code
              ? npdData?.data[0]?.code
              : "-"}
        </div>
      </>
    );
  };
  const EnquiryName = ({ id }: any) => {
    const { data: npdOrQuotationData, isLoading: npdOrQuotationDataLoading } =
      useGetQuotationOrNpdQuery(id);
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(npdOrQuotationData?.data[0]?.sales_lead);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npdOrQuotationData?.data[0]?.npd,
    );

    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]?.enquiry_category_name
            ? quotationData?.data[0]?.enquiry_category_name
            : npdData?.data[0]?.enquiry_category_name}
        </div>
      </>
    );
  };
  const LeadName = ({ id }: any) => {
    const { data: npdOrQuotationData, isLoading: npdOrQuotationDataLoading } =
      useGetQuotationOrNpdQuery(id);
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(npdOrQuotationData?.data[0]?.sales_lead);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npdOrQuotationData?.data[0]?.npd,
    );
    return (
      <>
        <div>
          {quotationData?.data[0]?.lead_name
            ? quotationData?.data[0]?.lead_name
            : npdData?.data[0]?.lead_name}
        </div>
      </>
    );
  };
  const Status = () => {
    return (
      <>
        <div></div>
      </>
    );
  };
  const columns = [
    {
      title: isDispatch ? "Dispatch date" : "Created date",
      dataIndex: "order_punched_date",
      key: "date",
      sorter: (a: any, b: any) => {
        const dateA = isDispatch
          ? moment(
              a.dispatch_schedule[a.dispatch_schedule.length - 1]
                ?.dispatch_date,
            ).valueOf()
          : moment(a.order_punched_date).valueOf();

        const dateB = isDispatch
          ? moment(
              b.dispatch_schedule[b.dispatch_schedule.length - 1]
                ?.dispatch_date,
            ).valueOf()
          : moment(b.order_punched_date).valueOf();

        return dateA - dateB;
      },
      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <div>
            {isDispatch
              ? moment(
                  record?.dispatch_schedule[
                    record?.dispatch_schedule?.length - 1
                  ]?.dispatch_date,
                ).format("DD-MM-YYYY")
              : moment(record?.order_punched_date)?.format("DD-MM-YYYY")}
          </div>
        </>
      ),
    },
    {
      title: "Order  No.",
      dataIndex: "order_no",
      key: "name",
      // sorter: (a: any, b: any) => a.age - b.age,
      ellipsis: true,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <Code id={record?.quotation} />
        </>
      ),
    },
    {
      title: "Company",
      dataIndex: "address",
      key: "address",
      render: (text: any, record: any) => (
        <>
          <Companyname id={record?.quotation} />
        </>
      ),
      ellipsis: true,
    },
    {
      title: "Lead Name",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <LeadName id={record?.quotation} />
        </>
      ),
    },
    {
      title: "Enquiry Category",
      dataIndex: "age",
      key: "age",
      // sorter: (a: any, b: any) => a.age - b.age,
      ellipsis: true,
      render: (text: any, record: any) => (
        <>
          <EnquiryName id={record?.quotation} />
        </>
      ),
    },
    {
      title: "Advance Received",
      dataIndex: "advance_received_amount",
      key: "address",
      ellipsis: true,
      render: (text: any) => (
        <>
          <div color="purple">{text ? text : "-"}</div>
        </>
      ),
    },

    {
      title: "Status",
      dataIndex: "order_status",
      key: "age",
      ellipsis: true,

      render: (text: any) => (
        <>
          {text === 3 ? (
            <Tag color="green">Completed</Tag>
          ) : text === 2 ? (
            <Tag color="purple">Delivered</Tag>
          ) : text === 1 ? (
            <Tag color="magenta">Open</Tag>
          ) : (
            <Tag color="lime">In Progress</Tag>
          )}
        </>
      ),
    },
  ];

  // Export columns (for sending to backend)
  const exportColumns = [
    {
      dataIndex: OrderExportColumn.CREATED_DATE,
      title: OrderColumnLabels[OrderTableColumn.CREATED_DATE],
    },
    {
      dataIndex: OrderExportColumn.ORDER_NO,
      title: OrderColumnLabels[OrderTableColumn.ORDER_NO],
    },
    {
      dataIndex: OrderExportColumn.SALES_LEAD_ID,
      title: OrderColumnLabels[OrderTableColumn.SALES_LEAD_ID],
    },
    {
      dataIndex: OrderExportColumn.COMPANY_NAME,
      title: OrderColumnLabels[OrderTableColumn.COMPANY_NAME],
    },
    {
      dataIndex: OrderExportColumn.LEAD_NAME,
      title: OrderColumnLabels[OrderTableColumn.LEAD_NAME],
    },
    {
      dataIndex: OrderExportColumn.ENQUIRY_CATEGORY_NAME,
      title: OrderColumnLabels[OrderTableColumn.ENQUIRY_CATEGORY_NAME],
    },
    {
      dataIndex: OrderExportColumn.ADVANCE_RECEIVED_AMOUNT,
      title: OrderColumnLabels[OrderTableColumn.ADVANCE_RECEIVED_AMOUNT],
    },
    {
      dataIndex: OrderExportColumn.ORDER_STATUS_NAME,
      title: OrderColumnLabels[OrderTableColumn.ORDER_STATUS_NAME],
    },
  ];

  const columnOptions = exportColumns.map((col) => ({
    dataIndex: col.dataIndex,
    title: col.title,
  }));

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `In Progress`,
    },
    {
      key: "2",
      label: `Dispatch Added`,
    },
    {
      key: "3",
      label: `Delivered`,
    },
    {
      key: "4",
      label: `Completed`,
    },
  ];
  const onChange = (key: string) => {
    console.log(key);
  };
  const findIndexForObject = (array: [], object: any) => {
    return _.findIndex(array, object);
  };
  const order_id = searchParams.get("id");

  const targetObject = { id: Number(order_id) };
  const index = findIndexForObject(data?.results, targetObject);

  const [currentIndex, setCurrentIndex] = useState(index);

  const getObjectAtIndex = (array: [], index: number) => {
    const object = _.get(array, index);
    return object;
  };

  useEffect(() => {
    setCurrentIndex(index);
  }, [index]);
  useEffect(() => {
    if (currentIndex > -1) {
      const updatedObject: any = getObjectAtIndex(data?.results, currentIndex);

      navigate(
        `/order/details?id=${updatedObject?.id}&created_by=${updatedObject?.lead}`,
      );
    }
  }, [currentIndex]);
  const handleNext = () => {
    // console.log("final object trance", !contactLoading && object?.id);
    // navigate(`/contacts?id=${object?.id}`);

    if (currentIndex < data?.results?.length - 1) {
      setCurrentIndex(currentIndex + 1);

      // navigate(`/contacts?id=${object?.id}`);
      // setSearchParams({ ["id"]: object?.id });
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);

      // navigate(`/contacts?id=${object?.id}`);
    }
  };
  useEffect(() => {
    setIsProgress(true);
  }, []);

  const titleData = [
    "Date ",
    "Order  No.",
    "Code",
    "Company",
    "Lead name",
    "Advance",
    "Status",
  ];
  const CopyButton = () => {
    const currentURL = window?.location?.href;
    copy(currentURL)
      .then(() => {
        message.success("Link copied");
      })
      .catch((error) => {
        message.error("Failed to copy URL");
      });
  };
  const isOrder = location.pathname;
  const isOrderUrl = isOrder && isOrder.includes("/order/details");
  const { data: downloadedData, isFetching: downloadLoading } =
    useGetOrderDownloadDataQuery(
      downloadIds?.length > 0 ? downloadIds : idArray,
    );
  const handleDownload = () => {
    // Convert the data to a Blob
    // const blob = new Blob([downloadedData], {
    //   type: "application/vnd.ms-excel",
    // });

    // // Use the saveAs function to trigger the download
    // saveAs(blob, "contact-export.xlsx");
    if (downloadedData) {
      saveAs(downloadedData, "order-export.xlsx");
    } else {
      message.error("Error: Downloaded data is undefined.");
    }
  };

  const handleExportDownload = async () => {
    // Get selected columns array
    const selectedColumnsArray = (
      Object.keys(selectedColumns) as Array<keyof typeof selectedColumns>
    ).filter((key) => selectedColumns[key]);

    if (selectedColumnsArray.length === 0) {
      message.error("Please select at least one column to export");
      return;
    }

    try {
      // Build export payload for Orders
      const exportPayload: any = {
        module: "order",
        columns: selectedColumnsArray,
      };

      // Add order_status_id based on selected tab
      exportPayload.order_status_id = [orderStatus];

      // Add enquiry category filter if selected
      if (enquiryCategoryIds && enquiryCategoryIds.length > 0) {
        exportPayload.enquiry_category_id = enquiryCategoryIds;
      }

      // Make the API call
      const response = await exportSalesReport(exportPayload).unwrap();

      if (response.status === "success" && response.file_url) {
        message.success(response.message || "Export completed successfully");

        // Fetch and download the file
        const fileResponse = await fetch(response.file_url);
        const blob = await fileResponse.blob();
        saveAs(blob, response.file_name);

        // Close modal and reset filters
        setIsModalOpen(false);
        resetModalFilters();
      } else {
        message.error(response.message || "Export failed. Please try again.");
      }
    } catch (error: any) {
      console.error("Export error:", error);
      if (error?.data) {
        message.error(
          error.data.message ||
            error.data.errorDetails ||
            "Export failed. Please try again.",
        );
      } else {
        message.error("Something went wrong. Please try again.");
      }
    }
  };
  const widgetMenu = (
    <Menu>
      <Menu.Item
        disabled={!isOrderPdfReady}
        onClick={() => {
          handleOrderPdfDownload();
        }}
      // onClick={() => {
      //   navigate("/profile");
      // }}
      >
        <div>Download</div>
      </Menu.Item>
      <Menu.Item
        // onClick={() => {
        //   handleLogout();
        // }}
        onClick={() => {
          CopyButton();
        }}
      >
        <div className="logout-div">
          <Space>
            {/* <LoginOutlined className="logout-icon " /> */}
            <span className="logout-text ">Share</span>
          </Space>
        </div>
      </Menu.Item>
    </Menu>
  );
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    pageSize,
  ) => {
    setPageData({
      page: current,
      pageSize: pageSize,
    });
  };

  return (
    <>
      <div className="mt-24">
        <div className="order-tab-main-div-3 ">
          {/* <div className="orders-title ">Order</div> */}
          <Text
            value="Order"
            variant="wearlay-display"
            className="orders-title"
          />
          {/* <Tabs
            type="card"
            items={items}
            // onChange={onChange}
            onTabClick={onChange}
            className="order-main-div-2"
          ></Tabs> */}
          <div className="order-tab-main-div ">
            <div
              className={isInProgress ? "order-tabs-active" : "order-tabs"}
              onClick={() => {
                setIsProgress(true);
                setDelivery(false);
                setDispatch(false);
                setCompleted(false);
                setorderStatus(0);
              }}
            >
              In Progress
            </div>
            <div
              className={isDispatch ? "order-tabs-active" : "order-tabs"}
              onClick={() => {
                setIsProgress(false);
                setDelivery(false);
                setDispatch(true);
                setCompleted(false);
                setorderStatus(1);
              }}
            >
              Dispatch Added
            </div>

            <div
              className={isDelivery ? "order-tabs-active" : "order-tabs"}
              onClick={() => {
                setIsProgress(false);
                setDelivery(true);
                setDispatch(false);
                setCompleted(false);
                setorderStatus(2);
              }}
            >
              Delivered
            </div>
            <div
              className={isCompleted ? "order-tabs-active" : "order-tabs"}
              onClick={() => {
                setIsProgress(false);
                setDelivery(false);
                setDispatch(false);
                setCompleted(true);
                setorderStatus(3);
              }}
            >
              Completed
            </div>
          </div>
          <div className="order-tab-main-div-2 ">
            <div>
              <div
                className={isInProgress ? "order-tabs-active" : "order-tabs"}
                onClick={() => {
                  setIsProgress(true);
                  setDelivery(false);
                  setDispatch(false);
                  setCompleted(false);
                  setorderStatus(0);
                }}
              >
                In Progress
              </div>
              <div
                className={isDispatch ? "order-tabs-active" : "order-tabs"}
                onClick={() => {
                  setIsProgress(false);
                  setDelivery(false);
                  setDispatch(true);
                  setCompleted(false);
                  setorderStatus(1);
                }}
              >
                Dispatch Added
              </div>
            </div>
            <div>
              <div
                className={isDelivery ? "order-tabs-active" : "order-tabs"}
                onClick={() => {
                  setIsProgress(false);
                  setDelivery(true);
                  setDispatch(false);
                  setCompleted(false);
                  setorderStatus(2);
                }}
              >
                Delivered
              </div>
              <div
                className={isCompleted ? "order-tabs-active" : "order-tabs"}
                onClick={() => {
                  setIsProgress(false);
                  setDelivery(false);
                  setDispatch(false);
                  setCompleted(true);
                  setorderStatus(3);
                }}
              >
                Completed
              </div>
            </div>
          </div>
        </div>
        <div className="p-10 mt-24p">
          <div className="flex justify-between">
            {/* <div className="sales-title-1">Orders List</div> */}
            <Text value="Orders List" variant="wearlay-headline-2" />
            <div className="flex items-center h-full gap-2">
              <div className="search-resp ">
                <SearchBox placeholder="Search" />
              </div>
              <div className="relative">
                <CommonButton
                  variant="wearlay-with-icon"
                  icon={filter ? "/assets/close.svg" : "/assets/filter.svg"}
                  onClick={() => {
                    setFilter(!filter);
                  }}
                  className="download-btn-color"
                />
                {filter && (
                  <OrderFilter
                    setFilter={setFilter}
                    setFilterData={setFilterData}
                    filer={filter}
                    setSelectedRegion={setSelectedRegion}
                    selectedRegion={selectedRegion}
                  />
                )}
              </div>
              <CommonButton
                variant="wearlay-with-icon"
                icon={
                  data?.results?.length === 0
                    ? "/assets/disabledDownload.svg"
                    : "/assets/download.svg"
                }
                disabled={data?.results?.length === 0 || downloadLoading}
                isLoading={downloadLoading}
                // onClick={() => {
                //   handleDownload();
                // }}
                onClick={showModal}
              />
            </div>
          </div>
          <div className="resp-search">
            <SearchBox placeholder="Search" />
          </div>
          <div className="resp-table">
            <CommonTable
              datasource={data?.results}
              coloumn={columns}
              setDetailsOpen={setOpen}
              isLoading={isLoading || isFetching}
              setDownloadIds={setDownloadIds}
            />
            {data?.count > 0 && (
              <Row justify={"end"}>
                <Pagination
                  // current={pageData.page}
                  onChange={onPaginationChange}
                  total={data?.count}
                  pageSize={pageData?.pageSize}
                  defaultCurrent={1}
                  responsive={true}
                  onShowSizeChange={onShowSizeChange}
                  showSizeChanger={data?.count > 10 ? true : false}
                />
              </Row>
            )}
          </div>
        </div>
        <TableCard
          headingData={titleData}
          setOpen={setOpen}
          data={data?.results}
          loading={isLoading || isFetching}
        />
        {data?.count > 5 && (
          <Pagination
            // current={pageData.page}
            onChange={onPaginationChange}
            total={data?.count}
            pageSize={pageData?.pageSize}
            className="pagination-resp"
            defaultCurrent={1}
            onShowSizeChange={onShowSizeChange}
            showSizeChanger={data?.count > 10 ? true : false}
          />
        )}
      </div>
      <Drawer
        title={
          <div className="flex justify-between items-center">
            <Text value="Order Preview" variant="wearlay-subtitle" />
            <div className="quotation-option">
              <Space>
                <Button className="flex items-center pdf-download-button">
                  {isOrderPdfReady ? (
                    <PDFDownloadLink
                      document={
                        <OrderPdf
                          quotationData={quotationData}
                          quotationByIdData={quotationByIdData}
                          npdData={npdData}
                          data={dataById}
                        />
                      }
                      // fileName="order.pdf"
                      fileName={`Order_${
                        quotationData?.data[0]?.sales_lead_id
                          ? quotationData?.data[0]?.sales_lead_id
                          : npdData?.data[0]?.sales_lead_id
                      }.pdf`}
                    >
                      {/* {({ blob, url, loading, error }) =>
                      loading ? (
                        "Loading document..."
                      ) : ( */}
                      <img
                        src="/assets/download.svg"
                        className=" h-full flex items-center downlaod-pdf justify-center"
                      ></img>
                      {/* )
                    } */}
                    </PDFDownloadLink>
                  ) : (
                    <img
                      src="/assets/download.svg"
                      className=" h-full flex items-center downlaod-pdf justify-center"
                      style={{ opacity: 0.4, cursor: "not-allowed" }}
                    ></img>
                  )}
                </Button>
                {/* <Button className="flex items-center ">
                  <img src="/assets/printer.svg"></img>
                </Button> */}
                <Button className="flex items-center pdf-download-button">
                  <img
                    src="/assets/share.svg"
                    onClick={() => {
                      CopyButton();
                    }}
                    className="downlaod-pdf"
                  ></img>
                </Button>
              </Space>
            </div>
            <Dropdown
              overlay={widgetMenu}
              trigger={["click"]}
              className="dropdown-click"
            >
              <img
                src="/assets/option.svg"
                className="quotation-option-2"
              ></img>
            </Dropdown>
            <div>
              <Space>
                <Button
                  onClick={() => {
                    handlePrevious();
                    // navigate(`/contacts?id=${object?.id}`);
                  }}
                  disabled={currentIndex === 0}
                >
                  <LeftOutlined />
                </Button>
                <Button
                  onClick={() => {
                    // navigate(`/contacts?id=${object?.id}`);
                    handleNext();
                  }}
                  disabled={currentIndex === data?.results?.length - 1}
                >
                  <RightOutlined />
                </Button>
              </Space>
            </div>
          </div>
        }
        width={600}
        placement="right"
        onClose={onClose}
        open={open || (isOrderUrl as boolean)}
        destroyOnClose={true}
      >
        <CloseOrder
          setPreview={setOpen}
          setNpdData={setNpdData}
          setQuotationData={setQuotationData}
          setQuotationByIdData={setQuotationByIdData}
        />
      </Drawer>

      {/* Export Modal for Orders */}
      <ExportModal
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        title="Orders Export"
        columnOptions={columnOptions}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleDownload={handleExportDownload}
        isExporting={isExporting}
      >
        {/* Enquiry Category Filter */}
        <MultiSelectFilter
          value={enquiryCategoryIds}
          onChange={setEnquiryCategoryIds}
          options={enquiryCategoryData || []}
          label="Enquiry Category"
          placeholder="Select enquiry categories"
        />
      </ExportModal>
    </>
  );
};
